import { InvoiceContractRepository } from "@/modules/facturae/domain/InvoiceContractRepository";
import { CommandDispatcher } from "@/modules/shared/domain/CommandDispatcher";
import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";
import { query_dispatcher_get, sync_command_dispatcher } from "@/api/client";
import store from "@/store";
export class ApiInvoiceContractRepository implements InvoiceContractRepository {

  command_dispatcher: CommandDispatcher
  query_dispatcher: QueryDispatcher
  constructor() {
      this.command_dispatcher = sync_command_dispatcher
      this.query_dispatcher = query_dispatcher_get
  }

  async check_user_einvoice_active_contract(company_id: number): Promise<boolean> {
    const user_id = store.getters['me/userData'].id;
    
    const res = await this.query_dispatcher.dispatch('check.user.has.active.envoice.contract', { 
      user_id,
      company_id 
    });
    
    return (res && res.any) || false;
  }

  async activate_trial_einvoice_contract(company_id: number): Promise<any> {
    try {
      const user_id = store.getters['me/userData'].id;

      return await this.command_dispatcher.dispatch('activate.trial.service.for.client', {
        user_id,
        company_id
      });

    } catch (error) {
      return {
        status: 500,
        data: 'failed',
        error: 'NetworkError',
        message: 'Error de conexión con el servidor'
      };
    }
  }
}